import React, { Component } from "react";
import { fetchStudentResultsAction } from "../../actions/studentResultsActions";
import { connect } from "react-redux";
import { PacmanLoader } from "react-spinners";
import { Row, Col, Card, CardBody } from "reactstrap";
import StudentResult from "../../components/Student/StudentResult";

class StudentResults extends Component {
  componentDidMount() {
    this.props.dispatch(fetchStudentResultsAction());
  }

  render() {
    const { results } = this.props;

    if (results.loading === true) {
      return (
        <div
          className="sweet-loading"
          style={{ position: "fixed", top: "50%", left: "50%" }}
        >
          <PacmanLoader color={"#20a8d8"} loading={true} />
        </div>
      );
    }

    const resultList = results.result.map((result, i) => (
      <Col md="3" xs="12" key={i}>
        <StudentResult result={result} />
      </Col>
    ));

    return (
      <div className="animated fadeIn">
        <Card>
          <CardBody>
            <h4>Mina bästa resultat</h4>
            <Row>{resultList}</Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = store => {
  return {
    results: store.studentResultsReducer
  };
};

export default connect(mapStateToProps)(StudentResults);
